import { useBaseMetadataForLinkedEntities, useModuleFederationContext, useTranslation } from '@msdk/common'
import { FormTabDefinition } from '@msdk/definitions'
import React from 'react'

import { resolveItem } from '../../utils'
import { ImportedComponentErrorBoundary } from '../ImportedComponentBoundary'

export interface TabLabelProps {
  def: FormTabDefinition
}

interface Props {
  def: FormTabDefinition
  entityName: string
  formName: string
}

export function TabLabel(props: Props) {
  const t = useTranslation()
  const modules = useModuleFederationContext()
  const baseMetadata = useBaseMetadataForLinkedEntities(props.entityName, props.formName)
  const msModule = baseMetadata ? modules.loadedModules[baseMetadata.msProvider] : undefined
  const ImportedComponent = msModule ? resolveItem(msModule, props.def.labelCustomUI) : undefined
  const componentProps: TabLabelProps = {
    def: props.def,
  }

  return (
    <>
      {ImportedComponent && (
        <ImportedComponentErrorBoundary>
          <ImportedComponent {...componentProps} />
        </ImportedComponentErrorBoundary>
      )}
      {!ImportedComponent && <>{t(props.def.idml, props.def.description)}</>}
    </>
  )
}
